exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect.form-control[data-v-6424dca1] {\n    height:34px!important;\n}\nselect.to-check[data-v-6424dca1] {\n    border:1px solid rgba(206, 0, 91, 0.66)\n}\n.green[data-v-6424dca1] {\n    color: green;\n}\n.red[data-v-6424dca1] {\n    color: red;\n}\n", ""]);

// exports
